import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { MyBusinessRoutingModule } from './my-business-routing.module';
import { NewBusinessComponent } from './pages/new-business/new-business.component';
import { EditBusinessComponent } from './pages/edit-business/edit-business.component';
import { BusinessesComponent } from './pages/businesses/businesses.component';
import { BusinessFormComponent } from './components/business-form/business-form.component';
import { ProfitAndLossComponent } from './pages/profit-and-loss/profit-and-loss.component';
import { MyBusinessApiService } from './services/my-business.api.service';
import { MetricsModule } from '@app/modules/metrics/metrics.module';
import { TransactionsImportComponent } from './pages/transactions-import/transactions-import.component';
import { TransactionEditComponent } from './pages/transaction-edit/transaction-edit.component';
import { TransactionFormComponent } from './components/transaction-form/transaction-form.component';
import { TransactionAddComponent } from './pages/transaction-add/transaction-add.component';
import { TransactionsListComponent } from './pages/transactions-list/transactions-list.component';
import { TransactionsScheduledComponent } from './components/transactions-scheduled/transactions-scheduled.component';
import { RecurrenceSchedulePipe } from './pipes/recurrence-schedule.pipe';
import { TransactionTotalPipe } from './pipes/transaction-total.pipe';
import { AdjustmentsComponent } from './pages/adjustments/adjustments.component';
import { BusinessesModule } from '@app/modules/businesses/businesses.module';
@NgModule({
  declarations: [
    NewBusinessComponent,
    EditBusinessComponent,
    BusinessesComponent,
    BusinessFormComponent,
    ProfitAndLossComponent,
    TransactionsImportComponent,
    TransactionEditComponent,
    TransactionFormComponent,
    TransactionAddComponent,
    TransactionsListComponent,
    TransactionsScheduledComponent,
    RecurrenceSchedulePipe,
    TransactionTotalPipe,
    AdjustmentsComponent,
  ],
  imports: [CommonModule, MyBusinessRoutingModule, SharedModule, MetricsModule, BusinessesModule, MatDialogModule],
  providers: [MyBusinessApiService],
})
export class MyBusinessModule {}
